<template>
  <div class="chat-item">
    <template v-if="data.right == 1">
      <div class="right-chat">
        <!-- 文字 -->
        <img src="@/assets/loader1.svg" class="l-img" v-if="data.loading == 1">
        <div class="news" v-html="data.title" v-if="data.type == 0"></div>
        <!-- 语音 -->
        <div class="news voice" v-if="data.type == 1" @click="playVoice(data)">
          <div class="play-voice-d" v-show="data.isPlay"></div>
          <span>{{ data.time }}"</span>
          <img src="@/assets/msg/voice_right.png" alt="" />
        </div>
        <!-- 图片 -->
        <div class="news-img" v-if="data.type == 2">
          <van-image :src="data.title" @click="imagePreview([data.title])" />
        </div>
        <div class="news msg-1 left" :class="data.pay_status ? 'message2' : ''" v-if="data.type == 3">
          <div class="msg-text voice flex_items flex flex_items">
            <img src="@/assets/msg/msg2.png" v-if="data.pay_status" style="width: 30px;flex-shrink: 0;" class="mr20" />
            <img  src="@/assets/msg/msg1.png" v-else style="width: 30px;flex-shrink: 0;" class="mr20" />
            <div class="">
              <div class="f30 bold"><span class="mr20">{{data.pay_status ? '已付款' : '邀请付款'}}</span>{{data.money}}元</div>
              <div class="mt10 f28" style="font-weight: normal;" v-if="data.title">{{data.title}}</div>
            </div>
          </div>
        </div>
        <div class="head-img">
          <van-image
            width="0.8rem"
            height="0.8rem"
            fit="cover"
            :src="data.avatar"
          />
        </div>
      </div>
    </template>
    <template v-if="data.right == 0">
      <div>
        <div class="left-chat" v-if="data.status == 0">
          <div class="head-img">
            <van-image
              width="0.8rem"
              height="0.8rem"
              fit="cover"
              :src="data.avatar"
            />
          </div>
          <div class="news" v-html="data.title" v-if="data.type == 0"></div>
          <!-- 语音 -->
          <div
            class="news voice"
            v-if="data.type == 1"
            @click="playVoice(data)"
          >
            <img src="@/assets/msg/voice_left.png" alt="" />
            <span>{{ data.time }}"</span>
            <div class="play-voice-d" v-show="data.isPlay"></div>
          </div>
          <div class="news-img" v-if="data.type == 2">
            <van-image :src="data.title" @click="imagePreview([data.title])" />
          </div>
          <div class="news msg-1 right" :class="data.pay_status ? 'message2' : ''" v-if="data.type == 3" @click="userPay(data)">
            <div class="msg-text voice flex_items flex flex_items">
              <img src="@/assets/msg/msg2.png" v-if="data.pay_status" style="width: 30px;flex-shrink: 0;" class="mr20" />
              <img  src="@/assets/msg/msg1.png" v-else style="width: 30px;flex-shrink: 0;" class="mr20" />
              <div class="">
                <div class="f30 bold"><span class="mr20">{{data.pay_status ? '已付款' : '邀请付款'}}</span>{{data.money}}元</div>
                <div class="mt10 f28" style="font-weight: normal;" v-if="data.title">{{data.title}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 系统消息 -->
        <div v-else class="sys-msg">
          <div class="syetem-notice">
            {{ data.title }}
          </div>
        </div>
      </div>
    </template>
    <!-- 买课倒计时 通知按钮 -->
    <!-- <div class="flex flex_center" v-if="data.msgStatus == 999 && isTeacher != 1">
      <div class="txt_center notic-btn main_bg cf" @click="noticeService(data)">
        {{data.timerOut <= 0 ? '通知' : data.timerOut +'秒后可通知'}}
      </div>
    </div> -->

  </div>
</template>

<script>
import BenzAMRRecorder from "benz-amr-recorder";

/**
@description:
@createTime:2021-08-27
@create:wq
*/
export default {
  name: "",
  props: {
    data: {},
    reloadTimer:{
      default:0
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {
    reloadTimer(n){
      this.$forceUpdate()
    }
  },
  mounted() {},
  created() {},
  methods: {
    playVoice(data) {
      let that = this;
      var amr = new BenzAMRRecorder();
      amr
        .initWithUrl(data.title)
        .then(function() {
          amr.play();
          that.$set(data, "isPlay", true);
        })
        .catch((res) => {
          console.log(res);
          that.Toast.fail("播放错误");
        });
      amr.onEnded(function() {
        data.isPlay = false;
      });
      amr.isInit;
    },
    userPay(item){
      this.$emit('userPay', JSON.stringify(item))
    }
  },
};
</script>
<style lang="scss" scoped>
.chat-item {
  margin-bottom: 0.3rem;
}
.head-img {
  width: 0.8rem;
  height: 0.8rem;
  border: 0.04rem solid #ffffff;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-items: center;
  img {
    width: 100%;
  }
  // margin-right: 0.2rem;
}
.left-chat,
.right-chat {
  display: flex;
  align-items: flex-start;
}
.left-chat {
  .head-img {
    margin-right: 0.2rem;
  }
  .news::before {
    content: "";
    position: absolute;
    top: 0.4rem;
    left: -0.18rem;
    transform: translateY(-50%);
    border-right: 0.2rem solid #ffffff;
    border-top: 0.2rem solid transparent;
    border-bottom: 0.2rem solid transparent;
  }
  .news-img {
    /deep/ .van-image__error-icon {
      margin-left: 0.3rem;
    }
  }
}
.right-chat {
  justify-content: flex-end;
  .head-img {
    margin-left: 0.2rem;
  }
  .news {
    background: #4fd9d5;
    color: #ffffff;
  }

  .news::before {
    content: "";
    position: absolute;
    top: 0.4rem;
    right: -0.18rem;
    transform: translateY(-50%);
    border-left: 0.2rem solid #4fd9d5;
    border-top: 0.2rem solid transparent;
    border-bottom: 0.2rem solid transparent;
  }
  .news-img {
    /deep/ .van-image__error-icon {
      margin-right: 0.3rem;
    }
  }
}

.news {
  font-size: 0.3rem;
  font-weight: bold;
  color: #333333;
  background: #ffffff;
  padding: 0.18rem;
  max-width: 5rem;
  border-radius: 10px;
  // display: flex;
  // flex-wrap: wrap;
  // // justify-content: center;
  // align-items: center;
  position: relative;
  word-break: break-all;
  img {
    max-width: 3rem;
  }
}
.news-img {
  max-width: 4rem;
}
.voice {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  img {
    width: 16px;
    margin-right: 5px;
  }
  .play-voice-d {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: red;
    align-self: flex-start;
    position: absolute;
    top: 0;
    right: -10px;
  }
}
.right-chat {
  .voice {
    img {
      margin-right: 0;
      margin-left: 5px;
    }
    .play-voice-d {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: red;
      align-self: flex-start;
      position: absolute;
      top: 0;
      left: -10px;
    }
  }
}
.sys-msg {
  display: flex;
  justify-content: center;
  .syetem-notice {
    font-size: 0.24rem;
    color: #ffffff;
    background: #cccccc;
    border-radius: 0.22rem;
    padding: 0 0.34rem;
    display: inline-block;
    max-width: 6rem;
    text-align: center;
  }
}
.l-img{
  width: 20px;
  margin-right: 5px;
}

.news{
  &.msg-1{
    max-width: 5rem;
    display: flex;
    min-width: 3.5rem;
    background: #4fd9d5;
    &.right{
      &::before{
        border-right: 0.2rem solid #4fd9d5;
      }
    }
    .msg-text{
      color: #DCF7F6;
      text-align: left;
    }
    &.message2{
      color: #A7D5D3;
      background-color: #35AEAA;
      &.right{
        &::before{
          border-right: 0.2rem solid #35AEAA;
        }
      }
      &.left{
        &::before{
          border-left: 0.2rem solid #35AEAA;
        }
      }
    }
    .mr20{
      margin-right: .2rem;
    }
  }

}
</style>
